// eslint-disable-next-line import/no-anonymous-default-export
export default {
  today: 'Today',
  title: 'Payment Calendar',
  subtitle: 'View all your payments on your calendar',
  exportToICS: 'Export as ICS',
  downloadICS: 'Download as ICS',
  autoSyncEnabled: 'Auto Sync Enabled',
  lastSync: 'Last',
  selectDate: 'Select a day',
  noEventsForDate: 'No payments for this date',
  receivables: 'Receivables',
  payables: 'Payables',
  frequency: 'Frequency',
  monthly: 'Monthly',
  yearly: 'Yearly',
  oneTime: 'One Time',
  receivable: 'Receivable',
  payable: 'Payable',
  amount: 'Amount',
  company: 'Company',
  domain: 'Domain',
  provider: 'Provider',
  notes: 'Notes',
  description: 'Description',
  recurringPayment: 'Recurring Payment',
  serverPayment: 'Server Payment',
  payment: 'Payment',
  fetchError: 'Calendar data could not be retrieved',
  calendarUpdated: 'Calendar updated',
  syncError: 'Synchronization error',
  webcalUrlCopied: 'Webcal URL copied',
  urlCopyError: 'URL could not be copied',
  noEventsToExport: 'No events to export',
  icsCreateError: 'ICS file could not be created',
  exportSuccess: 'Calendar successfully exported!',
  webcalUrlTitle: 'Webcal URL',
  copyUrl: 'Copy URL',
  openWebcalUrl: 'Open Webcal URL',
  webcal: 'Webcal',
  email: 'Email',
  phone: 'Phone',
  status: 'Status',
  statusReceived: 'Received',
  statusPending: 'Pending',
  statusOverdue: 'Overdue',
  received: 'Received',
  invoice: 'Invoice',
  addToGoogle: 'Add to Google',
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',
  sun: 'Sun',
  mon: 'Mon',
  tue: 'Tue',
  wed: 'Wed',
  thu: 'Thu',
  fri: 'Fri',
  sat: 'Sat'
};
